import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/css/main.css';
import './assets/css/layout.css';
import './assets/css/header.css';
import './assets/css/footer.css';
import './assets/css/animations.css';
import './assets/css/content.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
